import { StandardFeature } from '../standard/standard.feature';
import { Layer } from '@app/modules/cop/store/cop/models';
import { Dataset } from '@app/modules/core/store/models';
import { MarkerUrls } from '../feature.model';
import { API_BASE_URL } from '@app/core/constants';

export class POIDoorFeature extends StandardFeature {
  buildMarkerImageUrls(layer: Layer, dataset: Dataset, document: Document, cacheBuster: number): MarkerUrls {
    const { markerName, markerSize, color } = layer;
    const markerColor = color.replace('#', '');

    return {
      normal: `${API_BASE_URL}/v1/meta/markers/sample/${markerName}_${markerSize}_${markerColor}_TOPO-door_normal_${cacheBuster}.png`,
      selected: `${API_BASE_URL}/v1/meta/markers/sample/${markerName}_${markerSize}_${markerColor}_TOPO-door_selected_${cacheBuster}.png`
    };
  }
}
